import { Link } from "react-router-dom";

function PickupInstructions() {
  return (
    <div style={styles.container}>
      <h1>🏍️ Pickup Instructions</h1>

      <div style={styles.card}>
        <h2>📍 BikeRent Pickup Hub</h2>
        <p>Fish Market Road, Gokarna</p>

        <hr />

        <h3>⏰ Pickup Timing</h3>
        <p>
          Please arrive within <strong>30 minutes</strong> of your selected
          pickup time.
        </p>

        <h3>🪪 Required Documents</h3>
        <ul>
          <li>Valid Driving License (Original)</li>
          <li>Any Government ID (Aadhaar / Passport)</li>
        </ul>

        <h3>🪖 Helmet & Fuel</h3>
        <ul>
          <li>1 Helmet provided free</li>
          <li>Bike will be given with sufficient fuel</li>
          <li>Return bike with same fuel level</li>
        </ul>

        <h3>⚠️ Important Rules</h3>
        <ul>
          <li>No drinking & driving</li>
          <li>Late return charges may apply</li>
          <li>Any damage must be reported immediately</li>
        </ul>

        {/* ✅ ACTION BUTTONS */}
        <div style={styles.actions}>
          <Link to="/shop-location" style={styles.btn}>
            📍 View Shop Location
          </Link>

          {/* ✅ STEP 4 – Damage Policy */}
          <Link to="/damage-policy" style={styles.btn}>
            🛠 Damage Policy
          </Link>

          <a
            href="https://wa.me/918296695604"
            target="_blank"
            rel="noreferrer"
            style={styles.whatsapp}
          >
            💬 WhatsApp Support
          </a>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: "900px",
    margin: "auto",
    paddingTop: "90px",
  },
  card: {
    background: "#f9f9f9",
    padding: "25px",
    borderRadius: "12px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
  },
  actions: {
    display: "flex",
    gap: "15px",
    marginTop: "20px",
    flexWrap: "wrap",
  },
  btn: {
    padding: "10px 18px",
    background: "black",
    color: "white",
    textDecoration: "none",
    borderRadius: "6px",
  },
  whatsapp: {
    padding: "10px 18px",
    background: "#25D366",
    color: "white",
    textDecoration: "none",
    borderRadius: "6px",
  },
};

export default PickupInstructions;
